/**
 * @class ValidatorView
 */
export default class ValidatorView {
    badges = new Map();

    constructor(validator, views = []) {
        this.validator = validator;
        this.views = views;

        this.validator.on('validate', problems => this.updateView(problems));
        this.updateView(this.validator.getProblems());
    }

    updateView(problems) {
        this.views.forEach(view => view.updateView(problems));
    }
}
